export function GripVertical({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='9' cy='6' r='1.5' />
      <circle cx='15' cy='6' r='1.5' />
      <circle cx='9' cy='12' r='1.5' />
      <circle cx='15' cy='12' r='1.5' />
      <circle cx='9' cy='18' r='1.5' />
      <circle cx='15' cy='18' r='1.5' />
    </svg>
  );
}
